import styled from 'styled-components'
import { darkOrange, black, white, warmTint } from '@/theme/colors'
import { shadows, radii, media, motion } from '@/theme/tokens'
import { text } from '@/theme/typography'




export const MembersGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 18px;

	${media.phone} {
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}
`

export const MemberCard = styled.div`
	background: ${white};
	border-radius: ${radii.card};
	padding: 24px 12px;
	box-shadow: ${shadows.card};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`


export const MemberCardName = styled.div`
	${text.label}
	color: ${black};
	text-align: center;
`

/**
 * The empty seat at the end of the grid. Mirrors a member card's geometry but
 * stays deliberately flat (no shadow) and warm-tinted, so it reads as an
 * invitation rather than a person.
 */
export const InviteGhostCard = styled.button`
	background: ${warmTint};
	border: none;
	border-radius: ${radii.card};
	padding: 24px 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	cursor: pointer;
	transition:
		filter ${motion.base},
		transform ${motion.fast};

	&:hover {
		filter: brightness(0.97);
	}

	&:active {
		transform: scale(0.98);
	}

	&:focus-visible {
		outline: 2px solid ${darkOrange};
		outline-offset: 2px;
	}
`


export const InviteGhostLabel = styled.span`
	${text.label}
	color: ${darkOrange};
	text-align: center;
`

